import React, { useState } from "react";
import { Box, ButtonBase, Grid, Stack, Link } from "@mui/material";
import {
  AppBarStyled,
  GradientBox,
  ItemContainer,
  Item,
  HamburgerButtonStyled,
  DropDownButton,
  GradientBox2,
} from "./NavbarStyled";
import logoLg from "../../assets/images/navbar/logo_lg.svg";
import ourTeam from "../../assets/images/navbar/our_team.svg";
import sponsor from "../../assets/images/navbar/sponsor.svg";
import collab from "../../assets/images/navbar/collab.svg";
import hamburger from "../../assets/images/navbar/hamburger.svg";
import {
  NavbarItem1,
  NavbarItem2,
  NavbarItem3,
  NavbarItem4,
  NavbarItem5,
  NavbarItem6,
  NavbarItem7,
} from "../../common/strings";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const itemStyle = {
    opacity: open ? 0 : 1,
  };

  const GradientBoxOpen = {
    background:
      "linear-gradient(247.34deg,rgba(249, 244, 244, 0.38) -16.85%,rgba(232, 227, 227, 0.29) 130.7%)",
    border: "1px solid rgba(255, 254, 254, 0.27)",
    boxShadow: "12px 12px 50px rgba(0, 0, 0, 0.11)",
    backdropFilter: "blur(27.1828px)",
    position: "relative",
    transition: "all 200ms ease-out",
  };

  const GradientBoxClose = {
    background: "transparent",
    border: "none",
    boxShadow: "none",
    backdropFilter: "none",
    position: "relative",
  };

  return (
    <AppBarStyled position="fixed" color="transparent">
      <Box sx={{ position: "relative" }}>
        <GradientBox sx={open ? GradientBoxClose : GradientBoxOpen}>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Box component="img" src={logoLg} sx={{ width: "30%" }} />
            <ItemContainer container justifyContent={"end"}>
              <Item
                item
                component={ButtonBase}
                xs={0}
                md={2.5}
                sx={{ itemStyle, display: { xs: "none", md: "inline" } }}
              >
                <Link
                  href="/"
                  style={{ color: "inherit", textDecoration: "inherit" }}
                >
                  {NavbarItem1}
                </Link>
              </Item>
              <Item
                item
                component={ButtonBase}
                xs={0}
                md={2.5}
                sx={{ itemStyle, display: { xs: "none", md: "inline" } }}
              >
                <Link
                  href="/aboutus"
                  style={{ color: "inherit", textDecoration: "inherit" }}
                >
                  {NavbarItem2}
                </Link>
              </Item>
              <Item
                item
                component={ButtonBase}
                xs={0}
                md={2.5}
                sx={{ itemStyle, display: { xs: "none", md: "inline" } }}
              >
                <Link
                  href="/events"
                  style={{ color: "inherit", textDecoration: "inherit" }}
                >
                  {NavbarItem3}
                </Link>
              </Item>
              <Item
                item
                component={ButtonBase}
                xs={0}
                md={2.5}
                sx={{ itemStyle, display: { xs: "none", md: "inline" } }}
              >
                <Link
                  href="/contactus"
                  style={{ color: "inherit", textDecoration: "inherit" }}
                >
                  {NavbarItem4}
                </Link>
              </Item>
              {HamburgerButton(open, setOpen)}
            </ItemContainer>
          </Stack>
        </GradientBox>
      </Box>
    </AppBarStyled>
  );

  function HamburgerButton(open, setOpen) {
    const handleClick = () => {
      setOpen(!open);
    };

    const itemStyle = {
      opacity: open ? 1 : 0,
      mt: "10px",
    };

    const plusStyle = {
      height: "30px",
      width: "30px",
      margin: "auto",
      transform: open ? "rotate(45deg)" : "rotate(0deg)",
      transition: "transform 200ms ease-out",
    };

    return (
      <Item item xs={0} md={1}>
        <HamburgerButtonStyled onClick={handleClick}>
          <Box sx={plusStyle} component="img" src={hamburger} />
        </HamburgerButtonStyled>
        {DropDown(open)}
      </Item>
    );

    function DropDown(open) {
      const DropDownStyle = {
        position: "absolute",
        top: "0px",
        right: "0",
        zIndex: "-1",
      };

      return (
        <Box sx={DropDownStyle}>
          <GradientBox2 sx={open ? GradientBoxOpen : GradientBoxClose}>
            <Grid
              container
              justifyContent={"center"}
              direction={"column"}
              sx={{ mt: "10vh", padding: 2 }}
            >
            {open &&(
              <Stack direction={"row"} sx={itemStyle} spacing={1}>
                <Item item component={ButtonBase} xs={12}>
                  <DropDownButton href="/ourteam" sx={{ ml: "auto" }}>
                    {NavbarItem5}
                  </DropDownButton>
                </Item>
                <Box
                  sx={{
                    background: "white",
                    height: "25px",
                    width: "25px",
                    borderRadius: "100%",
                    padding: "5px",
                  }}
                >
                  <Box
                    component="img"
                    src={ourTeam}
                    sx={{
                      width: "25px",
                      height: "25px",
                      margin: "auto !important",
                    }}
                  />
                </Box>
              </Stack>
            )}
            {open &&(
              <Stack direction={"row"} sx={itemStyle} spacing={1}>
                <Item item component={ButtonBase} xs={12}>
                  <DropDownButton href="/sponsor" sx={{ ml: "auto" }}>
                    {NavbarItem6}
                  </DropDownButton>
                </Item>
                <Box
                  sx={{
                    background: "white",
                    height: "25px",
                    width: "25px",
                    borderRadius: "100%",
                    padding: "5px",
                  }}
                >
                  <Box
                    component="img"
                    src={sponsor}
                    sx={{
                      width: "25px",
                      height: "25px",
                      margin: "auto !important",
                    }}
                  />
                </Box>
              </Stack>
            )}
            {open &&(
              <Stack direction={"row"} sx={itemStyle} spacing={1}>
                <Item item component={ButtonBase} xs={12}>
                  <DropDownButton href="/collab" sx={{ ml: "auto" }}>
                    {NavbarItem7}
                  </DropDownButton>
                </Item>
                <Box
                  sx={{
                    background: "white",
                    height: "25px",
                    width: "25px",
                    borderRadius: "100%",
                    padding: "5px",
                  }}
                >
                  <Box
                    component="img"
                    src={collab}
                    sx={{
                      width: "25px",
                      height: "25px",
                      margin: "auto !important",
                    }}
                  />
                </Box>
              </Stack>
            )}{" "}
              <div
                style={{
                  display: window.innerWidth >= 868 ? "none" : "block", 
                }}
              >
                {" "}
                { open && (
                <Stack direction={"row"} sx={itemStyle} spacing={1}>
                  <Item item component={ButtonBase} xs={12}>
                    <DropDownButton href="/" sx={{ mr: "auto" }}>
                      {NavbarItem1}
                    </DropDownButton>
                  </Item>
                </Stack>
                )}
                { open && (
                <Stack direction={"row"} sx={itemStyle} spacing={1}>
                  <Item item component={ButtonBase} xs={12}>
                    <DropDownButton href="/aboutus" sx={{ mr: "auto" }}>
                      {NavbarItem2}
                    </DropDownButton>
                  </Item>
                </Stack>
                )}
                { open && (
                <Stack direction={"row"} sx={itemStyle} spacing={1}>
                  <Item item component={ButtonBase} xs={12}>
                    <DropDownButton href="/events" sx={{ mr: "auto" }}>
                      {NavbarItem3}
                    </DropDownButton>
                  </Item>
                </Stack>
                )}
                { open && (
                <Stack direction={"row"} sx={itemStyle} spacing={1}>
                  <Item item component={ButtonBase} xs={12}>
                    <DropDownButton href="/contactus" sx={{ mr: "auto" }}>
                      {NavbarItem4}
                    </DropDownButton>
                  </Item>
                </Stack>
                )}
              </div>
            </Grid>
          </GradientBox2>
        </Box>
      );
    }
  }
};

export default Navbar;
